import PageBody from "../PageBody";
import CompanyDetail from "../components/pages/companies/CompanyDetail";

const EditCompanyPage = () => {
  return (
    <PageBody>
      <CompanyDetail />
    </PageBody>
  );
};

export default EditCompanyPage;
